<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Uredite poslovno enoto:
    </h2>

    <BusinessUnitForm
      @save="save"
      @cancel="cancel"
      :premiseTypes="premiseTypes"
      :businessUnit="businessUnit"
    />

    <h2>
      Glava računa
    </h2>
    <v-row>
      <v-col cols="12" md="6" offset-md="3">
        <InvoiceTextForm
          ref="headerInput"
          v-model="invoiceHeaderText"
          @save="saveInvoiceHeader"
        />
      </v-col>
    </v-row>

    <h2>
      Noga računa
    </h2>
    <v-row>
      <v-col cols="12" md="6" offset-md="3">
        <InvoiceTextForm
          v-model="invoiceFooterText"
          @save="saveInvoiceFooter"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { saveItem } from '@/utils/crudFunctions'
import BusinessUnitForm from '@/components/BusinessUnitForm'
import InvoiceTextForm from '@/components/InvoiceTextForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    BusinessUnitForm,
    InvoiceTextForm
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    childCompanyId: {
      required: true,
      type: Number
    },
    businessUnitId: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      invoiceHeaderText: '',
      invoiceFooterText: ''
    }
  },
  computed: {
    company () {
      return this.$store.state.companies.childCompanies[this.childCompanyId]
    },
    businessUnit () {
      return this.$store.state.clientsBusinessUnits.items[this.businessUnitId]
    },
    premiseTypes () {
      return objectToArray(this.$store.state.premiseTypes.items)
    }
  },
  methods: {
    ...mapActions('companies', ['loadChildCompany']),
    ...mapActions('clientsBusinessUnits', ['loadItem', 'saveItem']),
    ...mapActions('clientsBusinessUnits', {
      loadInvoiceHeader: 'getHeader',
      loadInvoiceFooter: 'getFooter',
      setInvoiceHeader: 'setHeader',
      setInvoiceFooter: 'setFooter'
    }),
    ...mapActions('premiseTypes', { loadPremiseTypes: 'loadItems' }),
    save ({ data }) {
      saveItem({ childCompanyId: this.childCompanyId, item: { ...data, id: this.businessUnitId } }, 'ClientsBusinessUnits', this)
    },
    cancel () {
      this.$router.push({ name: 'ClientsBusinessUnits' })
    },
    saveInvoiceHeader () {
      this.setInvoiceHeader({ childCompanyId: this.childCompanyId, businessUnitId: this.businessUnitId, header: this.invoiceHeaderText })
        .then(response => {
          // this.$notify({ type: 'success', text: 'Podatki so bili uspešno shranjeni' })
        })
        .catch(anErr => {
          this.$notify({ type: 'error', text: 'Prišlo je do napake pri shranjevanju podatkov' })
        })
    },
    saveInvoiceFooter () {
      this.setInvoiceFooter({ childCompanyId: this.childCompanyId, businessUnitId: this.businessUnitId, footer: this.invoiceFooterText })
        .then(response => {
          // this.$notify({ type: 'success', text: 'Podatki so bili uspešno shranjeni' })
        })
        .catch(anErr => {
          this.$notify({ type: 'error', text: 'Prišlo je do napake pri shranjevanju podatkov' })
        })
    },
    defaultHeaderHtml () {
      const companyName = this.company.name ? this.company.name.toUpperCase() : ''
      const companyAddress = this.company.address ? this.company.address.toUpperCase() : ''
      const companyCity = this.company.city ? this.company.city.toUpperCase() : ''
      const businessUnitName = this.businessUnit.name ? this.businessUnit.name.toUpperCase() : ''
      const businessUnitAddress = this.businessUnit.address ? this.businessUnit.address.toUpperCase() : ''
      const businessUnitCity = this.businessUnit.city ? this.businessUnit.city.toUpperCase() : ''
      const businessUnitHouseNumberAddition = this.businessUnit.house_number_addition ? this.businessUnit.house_number_addition.toUpperCase() : ''
      let headerHtml = `
          <p style="text-align: center;">${companyName}</p>
          <p style="text-align: center;">${companyAddress}, ${this.company.post_code} ${companyCity}</p>
          <p style="text-align: center;">${this.company.tax_bound ? 'ID za DDV: SI' : 'DAVČNA ŠT.: '}${this.company.tax_number}</p>
          <h3 style="text-align: center;">${businessUnitName}</h3>
        `
      if (this.allPeData()) {
        headerHtml += `<p style="text-align: center;">PE: ${businessUnitAddress} ${this.businessUnit.house_number}${businessUnitHouseNumberAddition}, ${this.businessUnit.post_code} ${businessUnitCity}</p>`
      }
      return headerHtml
    },
    allPeData () {
      return true
    }
  },
  created () {
    Promise.all([
      this.loadInvoiceHeader({ childCompanyId: this.childCompanyId, businessUnitId: this.businessUnitId }),
      this.loadInvoiceFooter({ childCompanyId: this.childCompanyId, businessUnitId: this.businessUnitId }),
      this.loadItem({ childCompanyId: this.childCompanyId, businessUnitId: this.businessUnitId }),
      this.loadChildCompany(this.childCompanyId),
      this.loadPremiseTypes()
    ])
      .then(items => {
        this.invoiceHeaderText = items[0] || this.defaultHeaderHtml()
        this.invoiceFooterText = items[1] || ''
        this.asyncDataStatus_fetched()
      })
  }
}
</script>
